import { Building2, Link2, ShieldCheck, Users } from 'lucide-react';

import { ModeGestion } from '../modeGestion';

export type { ModeGestion } from '../modeGestion';
export type SourceTitulaire = 'EXISTANTE' | 'CREER';

interface ChoiceCardProps {
  icon: typeof Building2;
  title: string;
  description: string;
  onClick: () => void;
}

const ChoiceCard: React.FC<ChoiceCardProps> = ({ icon: Icon, title, description, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="flex flex-col items-start gap-3 rounded-xl border border-gray-200 bg-white p-6 text-left shadow-sm transition-all hover:-translate-y-0.5 hover:border-primary/40 hover:shadow-md"
  >
    <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary/10">
      <Icon className="h-5 w-5 text-primary" />
    </div>
    <span className="text-base font-bold text-gray-900">{title}</span>
    <span className="text-sm text-gray-500">{description}</span>
  </button>
);

/** Étape 1 : le mode de gestion décide qui pilote la plateforme. */
export const ModeGestionCards: React.FC<{ onSelect: (mode: ModeGestion) => void }> = ({
  onSelect,
}) => (
  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
    <ChoiceCard
      icon={Users}
      title="Plateforme gérée"
      description="Sa personne morale gérante (compagnie ou courtier grossiste) gouverne :
        habilitations, équipe, portefeuille."
      onClick={() => onSelect('GEREE')}
    />
    <ChoiceCard
      icon={ShieldCheck}
      title="Plateforme administrée"
      description="Vous pilotez : le titulaire (cabinet de courtage ou compagnie) ne
        gouverne pas, vous décidez des produits et des habilitations."
      onClick={() => onSelect('ADMINISTREE')}
    />
  </div>
);

/** Étape 2 : la personne morale titulaire existe-t-elle déjà ? */
export const SourceTitulaireCards: React.FC<{
  mode: ModeGestion;
  onSelect: (source: SourceTitulaire) => void;
}> = ({ mode, onSelect }) => {
  const estAdministree = mode === 'ADMINISTREE';
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <ChoiceCard
        icon={Link2}
        title="Personne morale existante"
        description={
          estAdministree
            ? 'Un cabinet de courtage ou une compagnie déjà connu devient titulaire. Aucun compte n’est créé.'
            : 'Une compagnie ou un courtier grossiste déjà connu devient la gérante : ' +
              'ses membres actuels reçoivent la gouvernance.'
        }
        onClick={() => onSelect('EXISTANTE')}
      />
      <ChoiceCard
        icon={Building2}
        title={estAdministree ? 'Créer le cabinet' : 'Créer la personne morale'}
        description={
          estAdministree
            ? 'Le cabinet de courtage est créé avec la plateforme (compte fondateur inclus).'
            : 'La personne morale gérante est créée avec son compte corporate auto-généré ' +
              '(identifiants affichés une seule fois).'
        }
        onClick={() => onSelect('CREER')}
      />
    </div>
  );
};
